import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { toast } from "react-toastify";
import api from "../services/api";
import toastError from "../errors/toastError";

const errorCode = (error) => error?.response?.data?.error || "";

const PhoneVerificationGate = ({ user, onVerified }) => {
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [phone, setPhone] = useState(String(user?.phone || ""));
  // Corregir el número antes de confirmarlo (mal escrito o sin WhatsApp).
  const [changing, setChanging] = useState(false);
  const [newPhone, setNewPhone] = useState("");
  const [saving, setSaving] = useState(false);

  const send = async () => {
    setSending(true);
    try {
      await api.post("/auth/phone/send");
      setSent(true);
    } catch (error) {
      toastError(error);
      if (errorCode(error) === "ERR_PHONE_NOT_WHATSAPP") setChanging(true);
    } finally {
      setSending(false);
    }
  };

  const confirm = async (event) => {
    event.preventDefault();
    setConfirming(true);
    try {
      await api.post("/auth/phone/confirm", { code });
      onVerified();
    } catch (error) {
      toastError(error);
    } finally {
      setConfirming(false);
    }
  };

  const changeNumber = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post("/auth/phone/change", { phone: newPhone });
      setPhone(String(data?.phone || newPhone.replace(/\D/g, "")));
      setChanging(false);
      setNewPhone("");
      setCode("");
      setSent(true);
      toast.success("Número actualizado. Te enviamos el código por WhatsApp.");
    } catch (error) {
      toastError(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ maxWidth: 460, margin: "48px auto", padding: 24 }}>
      <Typography variant="h5" style={{ fontWeight: 800, marginBottom: 8 }}>
        Confirma tu WhatsApp
      </Typography>
      <Typography style={{ color: "#475569", marginBottom: 16, lineHeight: 1.5 }}>
        Te enviamos un código al {phone || "número que registraste"} para comprobar que es tuyo.
        Así evitamos cuentas repetidas.
      </Typography>

      {changing ? (
        <form onSubmit={changeNumber}>
          <TextField
            fullWidth
            variant="outlined"
            label="Tu número de WhatsApp"
            placeholder="Ejemplo: 51987654321"
            value={newPhone}
            onChange={(event) => setNewPhone(event.target.value.replace(/[^\d+\s-]/g, "").slice(0, 20))}
            helperText="Con el indicativo del país y sin el 0 inicial. Debe tener WhatsApp: ahí te llega el código."
            inputProps={{ inputMode: "tel", autoComplete: "tel" }}
            style={{ marginBottom: 12 }}
            autoFocus
          />
          <Button type="submit" variant="contained" color="primary" disabled={saving || newPhone.replace(/\D/g, "").length < 11}>
            {saving ? "Comprobando…" : "Guardar y enviar código"}
          </Button>
          <Button type="button" disabled={saving} onClick={() => setChanging(false)} style={{ marginLeft: 8 }}>
            Cancelar
          </Button>
        </form>
      ) : !sent ? (
        <>
          <Button variant="contained" color="primary" disabled={sending} onClick={send}>
            {sending ? "Enviando…" : "Enviar código"}
          </Button>
          <Button type="button" onClick={() => setChanging(true)} style={{ marginLeft: 8 }}>
            Cambiar número
          </Button>
        </>
      ) : (
        <form onSubmit={confirm}>
          <TextField
            fullWidth
            variant="outlined"
            label="Código de 6 dígitos"
            value={code}
            onChange={(event) => setCode(event.target.value.replace(/\D/g, "").slice(0, 6))}
            inputProps={{ inputMode: "numeric", autoComplete: "one-time-code" }}
            style={{ marginBottom: 12 }}
          />
          <Button type="submit" variant="contained" color="primary" disabled={confirming || code.length < 6}>
            {confirming ? "Confirmando…" : "Confirmar número"}
          </Button>
          <Button type="button" disabled={sending} onClick={send} style={{ marginLeft: 8 }}>
            Reenviar
          </Button>
          <Button type="button" onClick={() => setChanging(true)} style={{ marginLeft: 8 }}>
            Cambiar número
          </Button>
        </form>
      )}

      {!changing ? (
        <Typography style={{ color: "#64748b", fontSize: 13, marginTop: 16 }}>
          ¿El número está mal escrito o no tiene WhatsApp? Usa «Cambiar número».
        </Typography>
      ) : null}
    </div>
  );
};

export default PhoneVerificationGate;
